import { AspirationsToday } from '@/types.gql';
import { formatDateString } from '@/utils';

interface Props {
  selectedAspiration?: AspirationsToday;
}

export const OpuSearchFormIvmInfo = ({ selectedAspiration }: Props) => (
  <section
    style={{ backgroundColor: 'var(--color-background)' }}
    className="w-full rounded p-2 text-[11px]"
  >
    <InfoRow label="Donor" value={selectedAspiration?.donor ?? '-'} />
    <hr className="m-0 mx-1 p-0" />
    <InfoRow
      label="Date"
      value={
        selectedAspiration
          ? formatDateString(
              selectedAspiration.aspirationDate ?? '',
              'MM/dd/yyyy',
            )
          : '-'
      }
    />
    <InfoRow label="Site" value={selectedAspiration?.fertSite ?? '-'} />
    <InfoRow label="Account" value={selectedAspiration?.account ?? '-'} />
    <InfoRow label="IVM Tech" value={selectedAspiration?.ivmTech ?? '-'} />
  </section>
);

const InfoRow = ({ label, value }: { label: string; value: string }) => (
  <div className="grid grid-cols-[auto_1fr] gap-x-2 pt-1 first:pt-0">
    <span className="font-semibold text-gray-500">{label}:</span>
    <span
      className={`text-right font-bold tracking-wide break-words text-gray-900 tabular-nums ${label === 'Donor' ? 'divide-y text-[14px]' : ''}`}
    >
      {value}
    </span>
  </div>
);
